import { DefaultSeo } from "next-seo";

import baseSEO from "./base-seo.config.js";

const SeacrchEngineWrapper = (props) => <DefaultSeo {...baseSEO} {...props} />;

export default SeacrchEngineWrapper;
